import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import PageBanner from '../components/PageBanner';
import api from '../utils/api';
import './ConsultantPage.css';

function ConsultationsPage() {
  const [consultants, setConsultants] = useState([]);
  const [status, setStatus] = useState('loading'); // loading | ready | empty | error

  useEffect(() => {
    document.title = 'Consultation · Mind Spa';
    let active = true;
    api.getConsultants()
      .then((data) => {
        if (!active) return;
        if (Array.isArray(data) && data.length > 0) {
          setConsultants(data);
          setStatus('ready');
        } else {
          setStatus('empty');
        }
      })
      .catch(() => { if (active) setStatus('error'); });
    return () => { active = false; document.title = 'Mind Spa'; };
  }, []);

  return (
    <>
      <PageBanner title="Consultation" />

      <section className="cons-list">
        <div className="container">
          {status === 'loading' && (
            <div className="cons-state"><div className="cons-spinner" /><p>Loading…</p></div>
          )}

          {(status === 'empty' || status === 'error') && (
            <div className="cons-state">
              <h1>No consultants available yet</h1>
              <p>Please check back soon, or reach out via our contact page.</p>
              <Link to="/contact" className="btn-primary">Contact Mind Spa</Link>
            </div>
          )}

          {status === 'ready' && (
            <div className="cons-list__grid">
              {consultants.map((c) => {
                const tags = Array.isArray(c.tags) ? c.tags : [];
                return (
                  <Link key={c.slug} to={`/consultation/${c.slug}`} className="cons-list-card">
                    <div className="cons-list-card__avatar" style={c.gradient ? { background: c.gradient } : undefined}>
                      {c.image
                        ? <img src={c.image} alt={c.name} loading="lazy" decoding="async" />
                        : <span>{c.initials || c.name?.[0] || '?'}</span>}
                    </div>
                    <div className="cons-list-card__body">
                      <h3 className="cons-list-card__name">{c.name}</h3>
                      {c.title && <p className="cons-list-card__title">{c.title}</p>}
                      {c.tagline && <p className="cons-list-card__tagline">{c.tagline}</p>}
                      {tags.length > 0 && (
                        <div className="cons-chips">
                          {tags.slice(0, 3).map((t) => <span key={t} className="cons-chip">{t}</span>)}
                        </div>
                      )}
                      <span className="cons-list-card__cta">
                        Request a consultation
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                          <path d="M5 12h14M12 5l7 7-7 7" />
                        </svg>
                      </span>
                    </div>
                  </Link>
                );
              })}
            </div>
          )}
        </div>
      </section>
    </>
  );
}

export default ConsultationsPage;
